import { v4 as uuid } from "uuid";
export const randomIdString = () => {
    if (typeof window !== "undefined") return uuid();
    return (Math.abs(Date.now() * Math.random())).toString().replace(".", "")
};